export default __webpack_public_path__ + "static/media/LANDING3.43384f89.jpg";